<div class="ui basic segment" [class.loading]="isLoading">
    <ui-button type="primary" [disabled]="!file || isProcessing" (click)="import()" style="float: right"
        >{{ 'reporting.data-import.import' | translate }}
    </ui-button>

    <app-header title="reporting.data-import.bulkDataImport" [back]="true"></app-header>

    <ng-container *ngIf="!isProcessing">
        <div class="ui segment">
            <app-segment-header title="reporting.data-import.step1"></app-segment-header>
            {{ 'reporting.data-import.downloadSpreadsheetBelow' | translate }}
            <br />
            {{ entity.guide | translate }}
            <br />
            <br />
            <ui-button type="primary" [externalLink]="true" [url]="entity.templateLocation" style="float: left">
                {{ 'reporting.data-import.downloadBulkImportTemplate' | translate }}</ui-button
            >
            <div class="clear"></div>
        </div>

        <div class="ui segment">
            <app-segment-header title="reporting.data-import.step2"></app-segment-header>
            {{ 'reporting.data-import.uploadedCompletedSpreadsheetTohumi' | translate }}
            <form style="margin-top: 1em" class="app-grid" #form="ngForm">
                <mat-form-field class="columns-6">
                    <mat-label>{{ 'reporting.data-import.spreadsheet' | translate }}</mat-label>
                    <ui-mat-file-upload
                        #fileSelector="ngModel"
                        name="file"
                        [ngModel]="file"
                        (fileSelected)="file = $event"
                        placeholder="{{ 'reporting.data-import.uploadAFile' | translate }}"
                        [allowedTypes]="['.csv']"
                    ></ui-mat-file-upload>
                    <ui-button type="outline">{{ 'reporting.data-import.browse' | translate }}</ui-button>
                    <mat-error *ngIf="fileSelector.invalid"> {{ fileSelector.errors | formErrors }}</mat-error>
                </mat-form-field>
            </form>
        </div>

        <div class="ui segment">
            <app-segment-header title="reporting.data-import.step3"></app-segment-header>
            {{ 'reporting.data-import.processingOfTheBulkImport' | translate }}
            <br />
            {{ 'reporting.data-import.youWillReceiveEmailAlert' | translate }}
        </div>
    </ng-container>

    <ng-container *ngIf="isProcessing">
        <div class="ui segment">
            <app-segment-header title="reporting.data-import.processingInProgress"></app-segment-header>
            {{ 'reporting.data-import.processingOfTheBulkImport' | translate }}
            <br />
            {{ 'reporting.data-import.youWillReceiveEmailAlert' | translate }}
            <div class="ui hidden divider"></div>
            <div class="ui active blue progress" data-value="99" data-total="100" deprecated-ui-progress>
                <div class="bar"></div>
            </div>
        </div>
    </ng-container>
</div>
